!function ($, global) {
    'use strict';

    var $body = $('body');
    var $panel = $('#mobile-side-panel');
    var $menu = $('#menu-mobile-menu');

    var $target;

    $menu.on('click', '[href*=#]', function (e) {
        $target = $(e.target);

        $panel.modal('hide');
    });

    $panel.on('hidden.bs.modal', function () {
        setTimeout(function () {
            if ($target) {
                $('<a class="sr-only">').attr('href', $target.attr('href')).appendTo($body).trigger('click').remove();
                $target = null;
            }
        }, 50);
    });

}(jQuery, window);